export const stringIsEmpty = (text: string) => text.trim().length === 0;

export const stringLengthLessThan = (text: string, length: number) =>
  text.length < length;

export const stringLengthMoreThan = (text: string, length: number) =>
  text.length > length;

export const stringsAreEqual = (...strings: string[]) =>
  strings.reduce((acc, nextString, index) => {
    if (index < strings.length - 1) {
      return nextString === strings[index + 1];
    }
    return acc;
  }, true);

const isEmptyOrDigits = /^\d*$/;

export const stringIsEmtyOrDigits = (val: string) => isEmptyOrDigits.test(val);

const isNaturalNumber = /^(?:0|[1-9][0-9]*)$/;

export const stringIsNaturalNumber = (val: string) => isNaturalNumber.test(val);

export const stringIsNumber = (val: string) => !Number.isNaN(Number(val));

const isEmail = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])$/;

export const stringIsEmail = (val: string) => isEmail.test(val);

const isDns = /^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])$/;

export const stringIsDns = (val: string) => isDns.test(val);

const isDnsCandidate = /^[a-zA-Z0-9][a-zA-Z0-9-]*$/;

export const stringIsDnsCandidate = (val: string) => isDnsCandidate.test(val);

export function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const isLatinOrDigits = /^[A-Za-z0-9]+$/;

export const stringIsLatinOrDigits = (val: string) => {
  return isLatinOrDigits.test(val);
};

export const fillStringWithSpaces = (val: string) => {
  return val.split('').join(' ');
};

export const phoneLikeRexExp = /^\+[0-9- ]*$/;

export function stringIsUSDAmount(text: string) {
  if (!stringIsNumber(text)) {
    return false;
  }

  const [, decimalText] = text.split('.');

  if (decimalText && decimalText.length > 2) {
    return false;
  }

  return true;
}
